import { JSONRequests } from "./JSONRequests";
import { Quote, SimilarQuote } from "./types";

// FIX: all API endpoints are builded to output bundle and TS namespaces are deprecated
// see https://stackoverflow.com/questions/50415859/should-i-prefer-namespaces-or-classes-with-static-functions
// use import * as JSONRequests from "./JSONRequests";

export default {
    vote(content_type: string, quote_id: string | number, vote_type: "like" | "none") {
        return JSONRequests.post(`/api/thumbrating/vote/${content_type}/${quote_id}/${vote_type}/`);
    },

    report(quote_id: string | number, reason: string, comment: string) {
        return JSONRequests.post(`/api/quotes/${quote_id}/report/`, {
            reason: reason || "other",
            comment: comment || "",
        });
    },

    search(query: string, language_code: string): Promise<Quote[]> {
        return JSONRequests.get(`/api/quotes/search/`, {
            content: query,
            language_code: language_code,
        });
    },

    similar(query: string, language_code: string): Promise<SimilarQuote> {
        return JSONRequests.get(`/api/quotes/similar/`, {
            content: query,
            language_code: language_code,
        });
    },
};
